export default __webpack_public_path__ + "static/media/moldex-logo.de163cd2.svg";